import MojitoCore from 'mojito/core';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;

export default class ApplicationFooter extends UIViewImplementation {
    render() {
        return null;
    }
}
